"use client";

import { usePathname, useSearchParams } from "next/navigation";
import { useEffect } from "react";

export default function usePageView() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    const fullUrl = window.location.origin + pathname + (searchParams.toString() ? `?${searchParams.toString()}` : "");

    (window as any).dataLayer?.push({
      event: "page_view",
      page_location: fullUrl,
      page_path: pathname,
      page_hostname: window.location.hostname,
    });
  }, [pathname, searchParams]);
}